import React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import SaveIcon from '@mui/icons-material/Save'
import CancelIcon from '@mui/icons-material/Cancel'
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd'
import { Button } from 'react-admin'

export const EditableListViewActionsButtons = (
  {
    editing,
    showMenu = false,
    onClickMenu,
    onClickEdit,
    onClickSave,
    onClickCancel
  }) => {
  return (
    <div style={{ display: 'flex' }}>
      {editing ? (
        <>
          <Button onClick={onClickSave}>
            <SaveIcon />
          </Button>
          <Button onClick={onClickCancel}>
            <CancelIcon />
          </Button>
        </>
      ) : (
        <>
          {showMenu && (
            <Button onClick={onClickMenu}>
              <PlaylistAddIcon />
            </Button>
          )}
          <Button onClick={onClickEdit}>
            <EditIcon />
        </Button>
        </>
      )}
    </div>
  )
}
